import type { QuantityOfferConfig } from '@cod/config-schema';
import { initialFormState, initialTier, type FormState } from '@cod/form-tree';

/**
 * The state the live preview opens in.
 *
 * Its own module so it can be tested in node: `LivePreview` pulls in the api client (and through it
 * Nexo/axios), which needs a browser. Same reason as the `*.model.ts` files on the pages.
 */

/**
 * Open on the offer's own opening tier — the preselected one, else the first — at ITS quantity,
 * exactly as `FormSession` seeds a real open on the storefront.
 *
 * 🚨 Not cosmetic. `bg_color` and `border_color` — and so every colour palette — live ONLY on
 * `offerStyles().cardSelected`, so with `selectedTierId` unset no card is selected and picking a
 * palette changed nothing in the editor while working fine on the product page. The per-unit
 * variant pickers sit inside the selected card too, which is why the editor's `previewVariants`
 * had nothing to paint. The legacy renderer highlighted a card unconditionally
 * (`form-renderer/src/offers.ts`'s `Math.max(0, findIndex(preselect))`); this restores that on the
 * tree path.
 */
export function previewState(offer: QuantityOfferConfig | undefined): FormState {
  const base = initialFormState();
  const tier = offer ? initialTier(offer) : undefined;
  return tier ? { ...base, selectedTierId: tier.id, quantity: tier.quantity } : base;
}
